import { typedQueryClient, useTypedQuery } from "hooks";
import { AppointmentsQueryKeys } from "modules/Appointments/queryKeys";
import { APPOINTMENTS_STORAGE_KEYS } from "modules/Appointments/storageKeys";
import { getPreference, setPreference } from "utils/common";

export const useCarMakesToFilter = () =>
  useTypedQuery({ queryKey: AppointmentsQueryKeys.carMakesToFilter, initialData: getPreference(APPOINTMENTS_STORAGE_KEYS.MakePreference, []) }).data;

export const setCarMakesToFilter = (carMakes: string[]) => {
  typedQueryClient.setQueryData(AppointmentsQueryKeys.carMakesToFilter, carMakes);
  setPreference(APPOINTMENTS_STORAGE_KEYS.MakePreference, carMakes);
};
